<template>
  <div
    class="submit-section-modal-container"
    @click.stop="closeModal"
  >
    <div
      class="submit-section-modal-dialog"
      @click.stop
    >
      <div class="flex-row">
        <div class="top-left-corner">
          <slot name="top-left-corner">
            &nbsp;
          </slot>
        </div>
        <button
          class="icon-button pull-right"
          @click.stop="closeModal"
        >
          <icon
            name="cross"
            class="pull-right"
          ></icon>
        </button>
      </div>
      <div class="submit-section-modal-content">
        <slot></slot>
        <div class="dialog-button-row">
          <button
            class="dialog-button dialog-button-primary"
            @click.stop="handleSubmit"
          >
            {{ submitText }}
          </button>
          <button
            class="dialog-button"
            @click.stop="closeModal"
          >
            {{ closeText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    submitText: {
      type: String,
      default: 'Submit Section',
    },
    closeText: {
      type: String,
      default: 'Go Back',
    },
  },
  emits: ['close-modal', 'submit-section'],
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    handleSubmit() {
      this.$emit('submit-section');
    },
  },
};
</script>

<style lang='scss' scoped>
.submit-section-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(1.5px);
  z-index: 1010;
  display: grid;
  place-items: center;

  .submit-section-modal-dialog {
    width: 760px;
    height: 522px;
    background: #fff;
    color: black;
    padding: 1.5rem;

    .flex-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1.25rem;
    }

    .top-left-corner {
      height: 20px;
      font-size: 1.5rem;
    }

    .pull-right {
      height: 20px;
    }

    .icon-button {
      background: none;
      border: none;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
  }

  .submit-section-modal-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 522px;
    gap: 3rem;

    p {
      font-size: 1.5rem;
      text-align: center;
      font-weight: 600;
    }

    .dialog-button-row {
      display: flex;
      justify-content: center;
      gap: 1rem;
    }

    .dialog-button {
      width: 248px;
      height: 72px;
      color: #00629E;
      font-size: 1.25rem;
      font-weight: 600;
      background-color: white;
      border: 2px solid #00629E;
      border-radius: 4px;
    }

    .dialog-button-primary {
      background-color: #00629E;
      color: white;
    }
  }
}

</style>
